
class Timer {
	/*
	// exmaple usage:
	var myTimer = new Timer(function(){
		// perform action at end of timer
	}, 4000, 2); // perform 3 times (repeat 2 times - default repeat number is 0, performing once)
	// then later:
	myTimer.pause();
	// later still:
	myTimer.resume();
	*/

	constructor(callback, configObj) {
		var self = this,
			// defaults
			configInit = {
				delay: 5000,
				repeat: 0,
				visiblityPause: true,
				minReset: 1000,
			};
		this.config = $.extend(configInit, configObj); // define this config by extending default settings with input settings
		this.timeoutID = null; // the actual setTimeout item
		this.startTime = null; // timestamp [Date.now()] that the setTimeout was initiated
		this.paused = false; // active state of the Timer [not including visibility pauses]
		this.timePaused = 0; // amount of time the Timer was paused, for calcluating percentage complete
		this.minResumeAdjust = 0; // used to calculate percentage complete when the minReset time adds to the remaining time
		this.percentComplete = 0; // percentage of timer complete (used for getPerecent pause state)
		this.remaining = this.config.delay; // amount of time to run the setTimeout.  start with full amount remaining [can change with pause/resume]
		this.currentCount = 0;
		this.callback = callback;

		// listen for visiblity changes
		document.addEventListener("visibilitychange", () => {
			if (document.hidden) {
				// handle hidden
				// if this isn't already paused and is also listening to visibility events, then pause
				if (!self.paused && self.config.visiblityPause) {
					self.pause(false); // pass false to prevent setting paused to true
				}
			} else {
				// handle visible
				// if this isn't already paused and is also listening to visibility events, then resume
				if (!self.paused && self.config.visiblityPause) {
					self.resume();
				}
			}
		});

		// kick it off automatically
		this.resume();
	}

	pause(pauseForVisibility) {
		if (this.paused) {
			return;
		}
		// stop timeout
		window.clearTimeout(this.timeoutID);
		// update remaining - subtract the difference between current time and start time.
		var tChange = Date.now() - this.startTime;
		this.timePaused += tChange;
		this.remaining -= tChange;
		// calculate percentComplete to reduce processor expense
		this.percentComplete = (this.config.delay - this.remaining) / this.config.delay * 100;
		if (pauseForVisibility !== false) {
			this.paused = true;
		}
	}

	resume(minResetOvderride) {
		// there are no more times to loop through this, so quit
		if (this.currentCount > this.config.repeat) {
			return;
		}
		var self = this,
			// if no minResetOverride is defined, use the config.minReset value.
			tMinReset = (minResetOvderride !== null && typeof minResetOvderride !== 'undefined' && !isNaN(minResetOvderride)) ? minResetOvderride : this.config.minReset;

		// update minResumeAdjust for calculating perecentage
		if (tMinReset > this.remaining) {
			// add the difference to minResumeAdust, for percentage calcuation
			this.minResumeAdjust += tMinReset - this.remaining;
			// set rmaining to tMinReset
			this.remaining = tMinReset;
		}

		// no longer paused
		this.paused = false;
		// mark the time when this timer started
		this.startTime = Date.now();
		// make sure this timeout isn't somehow currently running
		window.clearTimeout(this.timeoutID);

		// start the timeout
		this.timeoutID = window.setTimeout(function () {
			// increment count
			self.currentCount++;
			//repeat, if necessary
			if (self.currentCount <= self.config.repeat) {
				self.restart();
			}
			// fire callback
			self.callback.call(null);
		}, this.remaining);
	}

	restart() {
		// reset to full delay
		this.remaining = this.config.delay;
		// reset timePaused to 0
		this.timePaused = 0;
		// reset minResumeAdjust to 0
		this.minResumeAdjust = 0;
		// resume
		this.resume();
	}

	getPercent() {
		if (this.paused) {
			return this.percentComplete;
		} else {
			// calculate current remaining time
			return (Date.now() - this.startTime + this.timePaused - this.minResumeAdjust) / this.config.delay * 100;
		}
	}
	/*
	logValues() {
		console.log('[Timer]------------------------------');
		console.log('[Timer].Date.now() - start: ', Date.now() - start);
		console.log('[Timer].timePaused: ', timePaused);
		console.log('[Timer].minResumeAdjust: ', minResumeAdjust);
		console.log('[Timer].config.delay: ', config.delay);
		console.log('[Timer].getPercent(): ', this.getPercent());
		console.log('[Timer]------------------------------');
	}
	*/

	getPaused() {
		return this.paused;
	}

	destroy() {
		// stop timeout
		window.clearTimeout(this.timeoutID);
		// remove event listener
		document.removeEventListener("visibilitychange", this.handleVisibilityChange);
	}
}

export default Timer;
